import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import hello from "../../assets/svg/hello.svg";
import { BsArrowsFullscreen } from "react-icons/bs";



function PreLoad({ setShowPreloader }) {

  const [showPrompt, setShowPrompt] = useState(false)

  useEffect(() => {
    if (!document.fullscreenElement) {
      setShowPrompt(true);
    }
  }, [])

  const enterFullScreen = async () => {
    try {
      await document.documentElement.requestFullscreen();

      setShowPrompt(false);

      const timer = setTimeout(() => {
        setShowPreloader(false);
      }, 3500);

      return () => clearTimeout(timer);

    } catch (error) {
      console.error("Fullscreen failed:", error);

    }
  };

  const skipFullScreen = () => {
    setShowPrompt(false);

    setTimeout(() => {
      setShowPreloader(false)
    }, 3500);
  }

  return (
    showPrompt ?
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 backdrop-blur-sm">
        <div className="w-[620px] h-fit rounded-2xl bg-black/60 p-6 shadow-2xl">

          <div className="mb-4 flex items-center gap-2">
            <div className="h-3 w-3 rounded-full bg-[#ff6157]" />
            <div className="h-3 w-3 rounded-full bg-[#ffbd2e]" />
            <div className="h-3 w-3 rounded-full bg-[#28c940]" />
          </div>

         
          <div className="flex items-center gap-2">
              <h2 className="font-applefont text-lg font-semibold text-white">
                Enter full screen
              </h2>
            <BsArrowsFullscreen className="text-white/80 size-3" />
          </div>

              <p className="mt-2 text-xs text-white">
                Enter full screen for better experience.
              </p>
           

          <button
            onClick={enterFullScreen}
            className="
                    mt-5
                    w-full
                    rounded-xl
                    bg-white/10
                    py-2.5
                    text-sm
                    font-medium
                    text-white
                    transition
                    hover:bg-black/80
                "
          >
            Enter Full Screen
          </button>
          <button
            onClick={skipFullScreen}
            className="
                    mt-5
                    w-full
                    rounded-xl
                    bg-red-950/70
                    py-2.5
                    text-sm
                    font-medium
                    text-white
                    transition
                    hover:bg-black/80
                "
          >
            close
          </button>
        </div>
      </div>
      :
      <div className="absolute flex h-screen w-full items-center justify-center bg-black">
        <div className=" flex w-[260px] flex-col items-center">

          <img
            src={hello}
            alt=""
            className="h-24 w-auto"
          />


        </div>
        <div className="absolute bottom-32 h-[2.5px] w-1/4 overflow-hidden bg-white/20">
          <motion.div
            className="h-full origin-left bg-white"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{
              duration: 3,
              ease: "linear",
            }}
          />
        </div>
      </div>
  );
}

export default PreLoad;